import React from "react";
import { FaNetworkWired, FaShieldAlt, FaShieldVirus, FaTimes } from "react-icons/fa";

function BulkIpToolbar({
  selectedCount = 0,
  loading = false,
  onEnable,
  onDisable,
  onManageIps,
  onClearIps,
  onClearSelection,
}) {
  if (!selectedCount) return null;

  return (
    <div className="accounts-bulk-ip-toolbar">
      <div className="accounts-bulk-ip-toolbar__summary">
        <span className="accounts-bulk-ip-toolbar__count">{selectedCount}</span>
        <span>
          account{selectedCount === 1 ? "" : "s"} selected
        </span>
      </div>

      <div className="accounts-bulk-ip-toolbar__actions">
        <button
          type="button"
          onClick={onEnable}
          disabled={loading}
          className="accounts-bulk-ip-btn accounts-bulk-ip-btn--primary"
        >
          <FaShieldAlt size={12} />
          <span>Enable IP check</span>
        </button>
        <button
          type="button"
          onClick={onDisable}
          disabled={loading}
          className="accounts-bulk-ip-btn"
        >
          <FaShieldVirus size={12} />
          <span>Disable IP check</span>
        </button>
        <button
          type="button"
          onClick={onManageIps}
          disabled={loading}
          className="accounts-bulk-ip-btn accounts-bulk-ip-btn--primary"
        >
          <FaNetworkWired size={12} />
          <span>Manage IPs</span>
        </button>
        <button
          type="button"
          onClick={onClearIps}
          disabled={loading}
          className="accounts-bulk-ip-btn"
        >
          <span>Clear IPs</span>
        </button>
        <button
          type="button"
          onClick={onClearSelection}
          disabled={loading}
          className="accounts-bulk-ip-btn accounts-bulk-ip-btn--ghost"
          aria-label="Clear selection"
        >
          <FaTimes size={12} />
          <span>Clear</span>
        </button>
      </div>
    </div>
  );
}

export default BulkIpToolbar;
